import React, { useState } from "react";
import "./AboutPage.css";
import Navbar from "./Navbar";
import BreadCrumb from "./BreadCrumb";
import Footer from "./Footer";
import Download from "./Download";
import MediaCenter from "./MediaCenter";
import Newsletter from "./Newsletter";

const Contact = () => {
    const [formData, setFormData] = useState({
        Fullname: "",
        email: "",
        phone: "",
        message: ""
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        let cleanedValue = value;

        if (name === "Fullname") {
            // Allow only letters and spaces
            cleanedValue = cleanedValue.replace(/[^A-Za-z\s]/g, '').replace(/\s+/g, ' ').trimStart();
        } else if (name === "message") {
            cleanedValue = cleanedValue.replace(/\s+/g, ' ').trimStart();
        } else if (name === "email") {
            cleanedValue = cleanedValue.replace(/\s/g, '');
        } else if (name === "phone") {
            cleanedValue = cleanedValue.replace(/[^0-9]/g, '');
        }

        setFormData({
            ...formData,
            [name]: cleanedValue
        });
    };

    const validate = () => {
        const newErrors = {};

        // Full Name
        if (!formData.Fullname.trim()) {
            newErrors.Fullname = "Full Name is required.";
        } else if (/\s{2,}/.test(formData.Fullname)) {
            newErrors.Fullname = "Full Name should not contain multiple spaces.";
        }

        // Email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!formData.email.trim()) {
            newErrors.email = "Email is required.";
        } else if (/\s/.test(formData.email)) {
            newErrors.email = "Email should not contain spaces.";
        } else if (!emailRegex.test(formData.email)) {
            newErrors.email = "Invalid email format.";
        }

        // Phone
        const phoneRegex = /^[6-9][0-9]{9}$/;
        if (!formData.phone.trim()) {
            newErrors.phone = "Phone number is required.";
        } else if (!phoneRegex.test(formData.phone)) {
            newErrors.phone = "Enter 10-digit number starting with 6-9.";
        }

        // Message
        if (!formData.message.trim()) {
            newErrors.message = "Message is required.";
        } else if (/\s{2,}/.test(formData.message)) {
            newErrors.message = "Message should not contain multiple spaces.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        if (!validate()) {
            e.preventDefault();
        }
    };

    return (
        <>
            <Navbar />
            <BreadCrumb />
            <div className="about-container">
                <section className="about-section risefx-benefits-section">
                    <div className="risefx-container">
                        <h1 className="risefx-title">Contact Us</h1>
                        <p className="risefx-description">
                            Got questions or need help? The RiseFX customer support team is at your service!
                        </p>
                        <section className="contact-section">
                            <div className="contact-container">
                                <div className="contact-info">
                                    <h2 className="contact-title">Rise FX</h2>
                                    <p className="contact-subtitle">Address</p>
                                    <p className="contact-text">
                                        P. O. Box 1912, Beachmont Kingstown<br />
                                        St. Vincent and the Grenadines.
                                    </p>
                                    <p className="contact-subtitle">E-mail</p>
                                    <p className="contact-text">
                                        <a href="mailto:enquiry@therisefx.com">enquiry@therisefx.com</a>
                                    </p>
                                    <p className="contact-subtitle">Phone Number</p>
                                    <p className="contact-text">+971 585904297</p>
                                </div>

                                <div className="contact-form">
                                    <h2 className="form-title">Send Us a Message</h2>
                                    <form
                                        action="https://api.web3forms.com/submit"
                                        method="POST"
                                        noValidate
                                        onSubmit={handleSubmit}
                                    >
                                        <input type="hidden" name="access_key" value="a854e710-e446-47b4-8f39-caa5c5ca9a94" />
                                        <input type="hidden" name="subject" value="New Enquiry From RiseFX Website" />

                                        <input
                                            type="text"
                                            name="Fullname"
                                            placeholder="Full Name"
                                            className="input-field"
                                            value={formData.Fullname}
                                            onChange={handleChange}
                                            onKeyDown={(e) => {
                                                if (!/^[a-zA-Z\s]$/.test(e.key) && e.key.length === 1) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            required
                                        />
                                        {errors.Fullname && <p className="error-text">{errors.Fullname}</p>}

                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="E-Mail"
                                            className="input-field"
                                            value={formData.email}
                                            onChange={handleChange}
                                            onKeyDown={(e) => {
                                                if (e.key === " ") e.preventDefault();
                                            }}
                                            required
                                        />
                                        {errors.email && <p className="error-text">{errors.email}</p>}

                                        <input
                                            type="tel"
                                            name="phone"
                                            placeholder="Phone Number"
                                            className="input-field"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            maxLength={10}
                                            required
                                        />
                                        {errors.phone && <p className="error-text">{errors.phone}</p>}

                                        <textarea
                                            name="message"
                                            placeholder="Message"
                                            className="textarea-field"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                        {errors.message && <p className="error-text">{errors.message}</p>}

                                        <button type="submit" className="submit-btn">SEND MESSAGE</button>
                                    </form>
                                </div>
                            </div>
                        </section>
                    </div>
                </section>
            </div>
            <MediaCenter />
            <Download />
            <Newsletter />
            <Footer />
        </>
    );
};

export default Contact;
